import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import { COMMON_TEXT } from '@/helpers/common-text';
import {
  COMPONENT_CHILD_ID_GROUP,
  COMPONENT_ID_GROUP,
  MEMORY_STORE,
  QUERY_STRING_STORE,
  USER_ID_KEY,
} from '@/helpers/constants';
import { generateRandomString } from '@/helpers/utility';
import { FieldArray, Form, Formik, getIn } from 'formik';
import { cloneDeep, isEqual } from 'lodash';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SignagePlay from './../SignagePlay';
import PropTypes from 'prop-types';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import './SignageComponentOverview.less';
import Toaster from 'src/components/CustomComponent/Toaster';

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class SignageComponentOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isUpdating: false,
      isSignagePlayDialogVisible: false,
      selectedPlaySetItems: [],
      signageComponentsList: [],
    };
    this.componentTypeOptions = [
      {
        label: COMMON_TEXT.MEETING_ROOM_USAGE,
        component_id: COMPONENT_ID_GROUP.ROOM_AVAILABILITIES,
        component_child_id: null,
      },
      {
        label: COMMON_TEXT.PEOPLE_COUNTS,
        component_id: COMPONENT_ID_GROUP.PEOPLE_COUNTS,
        component_child_id: null,
      },
      {
        label: `${COMMON_TEXT.AIR_QUALITY} - ${COMMON_TEXT.TEMPERATURE}`,
        component_id: COMPONENT_ID_GROUP.ENVIRONMENTS,
        component_child_id: COMPONENT_CHILD_ID_GROUP.TEMPERATURE,
      },
      {
        label: `${COMMON_TEXT.AIR_QUALITY} - ${COMMON_TEXT.HUMIDITY}`,
        component_id: COMPONENT_ID_GROUP.ENVIRONMENTS,
        component_child_id: COMPONENT_CHILD_ID_GROUP.HUMIDITY,
      },
      {
        label: `${COMMON_TEXT.AIR_QUALITY} - ${COMMON_TEXT.CARBON_DIOXIDE}`,
        component_id: COMPONENT_ID_GROUP.ENVIRONMENTS,
        component_child_id: COMPONENT_CHILD_ID_GROUP.CARBON_DIOXIDE,
      },
      {
        label: `${COMMON_TEXT.AIR_QUALITY} - ${COMMON_TEXT.NOISE_LEVEL}`,
        component_id: COMPONENT_ID_GROUP.ENVIRONMENTS,
        component_child_id: COMPONENT_CHILD_ID_GROUP.NOISE_LEVEL,
      },
    ];
    this.intervalTypeOptions = [
      { label: '15秒', value: 15 },
      { label: '30秒', value: 30 },
      { label: '45秒', value: 45 },
      { label: '60秒', value: 60 },
      { label: '75秒', value: 75 },
      { label: '90秒', value: 90 },
    ];
    this.branches = this.props?.sessionStore[MEMORY_STORE.BRANCHES] || [];
    this.floors = this.props?.sessionStore[MEMORY_STORE.FLOORS] || [];
    this.signageButtonList = [
      {
        label: `${COMMON_TEXT.SET}1`,
        value: 1,
      },
      {
        label: `${COMMON_TEXT.SET}2`,
        value: 2,
      },
      {
        label: `${COMMON_TEXT.SET}3`,
        value: 3,
      },
    ];
  }

  componentDidMount() {
    const { tenant } = this.state;
    const { signageComponentsList } = this.props;
    if (tenant) {
      this.setState({
        tenant,
        signageComponentsList,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring, signageComponentsList: signageComponentsListProp } =
      this.props;
    const { querystring: prevQuerystring, signageComponentsList: prevSignageComponentsList } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const isTenantChanged = tenant !== prevTenant;
    const isDataChanged = signageComponentsListProp !== prevSignageComponentsList;

    if (isTenantChanged || isDataChanged) {
      this.setState({
        tenant,
        signageComponentsList: signageComponentsListProp,
      });
    }
  }

  componentWillUnmount() {}

  onDragEnd = (result, formikProps) => {
    const { destination, source } = result;

    // Dropped outside the list
    if (!destination) {
      return;
    }

    // Dropped in the same position
    if (destination.index === source.index) {
      return;
    }

    const { signageComponentsList } = this.state;
    const activeItems = signageComponentsList.filter(item => item.is_deleted !== true);
    
    // Reorder the array
    const reorderedItems = Array.from(activeItems);
    const [removed] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, removed);

    // Update display_order for all items
    reorderedItems.forEach((item, index) => {
      item.display_order = index + 1;
    });

    // Update the full list (including deleted items) with new order
    const deletedItems = signageComponentsList.filter(item => item.is_deleted === true);
    const finalList = [...reorderedItems, ...deletedItems];

    this.setState({
      signageComponentsList: finalList
    });

    // Update Formik form values if available
    if (formikProps && formikProps.setFieldValue) {
      formikProps.setFieldValue('selectedActionList', finalList);
    }
  };

  updateSetComponents = async ({ updatePayLoad }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const updateRes = await workflowsApi.updateSettingsSignageComponents({
        apiPostWorkflowRequest: {
          ...updatePayLoad,
          tenantId: this.props.tenantId,
        }
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('update signage components error');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('update signage components error', error);
    }
    return { isSuccess: false };
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    // eslint-disable-next-line
    const { isSuccess } = await this.updateSetComponents({ updatePayLoad });

    if (isSuccess) {
      this.setState({ isUpdating: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        this.props.updateNotice({ isUpdate: true });
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        Toaster.error(COMMON_TEXT.SAVE_FAILED);
      });
    }
  };

  getUpdateDataPayload = ({ updateDataList }) => {
    let payload = {
      values: [],
    };
    const cloneUpdateDataList = cloneDeep(updateDataList);
    if (cloneUpdateDataList && cloneUpdateDataList.length > 0) {
      for (const dataItem of cloneUpdateDataList) {
        if (dataItem.is_deleted) {
          payload.values.push({
            signage_components_id: dataItem.signage_components_id,
            component_id: null,
          });
        } else {
          const cloneDataItem = { ...dataItem };
          delete cloneDataItem.rowId;
          payload.values.push({
            ...cloneDataItem,
          });
        }
      }
    }
    return payload;
  };

  renderListAction = () => {
    const { signageComponentsList } = this.state;

    const handleSubmit = (values, { errors }) => {
      if (errors) {
        Toaster.error(COMMON_TEXT.UNEXPECTED_ERROR);
      } else {
        const updateDataList = [];
        const { signageComponentsList } = this.state;
        for (let item of signageComponentsList) {
          const { initData } = item;
          if (!initData) {
            // new item
            updateDataList.push({
              ...item,
            });
          } else {
            // compare with initData
            const compareData = {
              ...item,
            };
            delete compareData.initData;
            if (!isEqual(initData, compareData)) {
              updateDataList.push({
                ...compareData,
              });
            }
          }
        }

        let hasChange = false;
        if (updateDataList.length > 0) {
          hasChange = true;
        }
        if (!hasChange) {
          Toaster.info(COMMON_TEXT.NO_CHANGE_TO_BE_SAVED);
        } else {
          // call api to update data
          const updatePayload = this.getUpdateDataPayload({ updateDataList });
          this.updateData({ updatePayLoad: updatePayload });
        }
      }
    };

    const addNewRow = ({ arrayHelpers }) => {
      if (!arrayHelpers.form.values['selectedActionList']) {
        arrayHelpers.form.values['selectedActionList'] = [];
      }
      const branchId = this.branches?.[0]?.branch_id;
      const floorId = this.floors?.filter(
        floor => floor.branch_id === branchId
      )?.[0].floor_id;
      arrayHelpers.form.values['selectedActionList'].push({
        signage_components_id: null,
        branch_id: branchId,
        floor_id: floorId,
        component_id: COMPONENT_ID_GROUP.ROOM_AVAILABILITIES,
        component_child_id: null,
        interval: this.intervalTypeOptions[1].value,
        user_id: +sessionStorage.getItem(USER_ID_KEY),
        display_order:
          arrayHelpers.form.values['selectedActionList'].length + 1,
        rowId: generateRandomString(10),
      });
      this.setState({
        signageComponentsList: arrayHelpers.form.values['selectedActionList'],
      });
    };

    const formSchema = Yup.object().shape({
      selectedActionList: Yup.array().of(
        Yup.object().shape({
          component_id: Yup.number().required(COMMON_TEXT.REQUIRED),
          branch_id: Yup.number().required(COMMON_TEXT.REQUIRED),
          floor_id: Yup.number().required(COMMON_TEXT.REQUIRED),
        })
      ),
    });

    return (
      <Formik
        key={`formik-1`}
        initialValues={{
          selectedActionList: signageComponentsList,
        }}
        validationSchema={formSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, handleChange, touched, errors, resetForm, setFieldValue }) => (
          <DragDropContext onDragEnd={(result) => this.onDragEnd(result, { setFieldValue })}>
            <Form id="signage-form">
              <FieldArray
                render={arrayHelpers => (
                  <div className="component-section">

                    <div className="table-container">
                      <div className="table-header">
                        <div className="header-cell"></div>
                        <div className="header-cell">拠点</div>
                        <div className="header-cell">フロア</div>
                        <div className="header-cell">コンポーネント</div>
                        <div className="header-cell">表示時間</div>
                        <div className="header-cell"></div>
                      </div>

                      <div className="table-separator"></div>

                      <Droppable droppableId="signage-components-list">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {values?.selectedActionList
                              ?.filter(item => item.is_deleted !== true)
                              .map((actionItem, index) => (
                                <Draggable 
                                  key={`action-item-${actionItem.rowId || actionItem.signage_components_id || index}`} 
                                  draggableId={`action-item-${actionItem.rowId || actionItem.signage_components_id || index}`}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className="table-row"
                                    >
                                      {this.renderItemAction(
                                        actionItem,
                                        index,
                                        arrayHelpers,
                                        {
                                          handleChange,
                                          touched,
                                          errors,
                                        }
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>

                      <div className="add-button-container">
                        <Button
                          type="button"
                          className="add-button"
                          onClick={() => addNewRow({ arrayHelpers })}
                        >
                          追加
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              />
            </Form>
          </DragDropContext>
        )}
      </Formik>
    );
  };

  renderItemAction = (
    actionItem,
    index,
    arrayHelpers,
    { handleChange, touched, errors }
  ) => {
    const { branch_id, component_id, component_child_id, floor_id, interval } =
      actionItem;

    const deleteButtonOnClicked = (e, { arrayHelpers, item, index }) => {
      const { component_id } = item;
      if (component_id) {
        confirmDialog({
          message: COMMON_TEXT.DELETE_CONFIRM_MESSAGE,
          header: COMMON_TEXT.DELETE_CONFIRMATION_HEADER,
          icon: '',
          accept: () =>
            deleteAccepted({ arrayHelpers, index, actionItem: item }),
          reject: () => {},
          acceptClassName: 'p-button-danger',
          rejectClassName: 'p-button-secondary p-button-text',
          appendTo: 'self',
        });
      } else {
        deleteAccepted({ arrayHelpers, index, actionItem: item });
      }
    };

    const deleteAccepted = ({ arrayHelpers, index, actionItem }) => {
      const { rowId } = actionItem;
      const itemIndex = arrayHelpers.form.values.selectedActionList.findIndex(
        item => item.rowId === rowId
      );
      if (itemIndex !== -1) {
        const { signageComponentsList } = this.state;
        const item = arrayHelpers.form.values.selectedActionList[itemIndex];
        if (item.signage_components_id) {
          item.is_deleted = true;
          arrayHelpers.form.values.selectedActionList[itemIndex] = item;
        } else {
          arrayHelpers.form.values.selectedActionList.splice(itemIndex, 1);
        }
        this.setState({ signageComponentsList });
      }
    };

    const fieldValueOnChanged = (e, { arrayHelpers, index, actionItem }) => {
      const { name, value } = e.target;
      const { rowId } = actionItem;
      const itemIndex = arrayHelpers.form.values.selectedActionList.findIndex(
        item => item.rowId === rowId
      );
      if (name === 'component_id') {
        const { component_id, component_child_id } = value;
        arrayHelpers.form.values.selectedActionList[itemIndex]['component_id'] =
          component_id;
        arrayHelpers.form.values.selectedActionList[itemIndex][
          'component_child_id'
        ] = component_child_id;
      } else {
        arrayHelpers.form.values.selectedActionList[itemIndex][name] = value;
      }
      const { signageComponentsList } = this.state;
      this.setState({ signageComponentsList });
    };

    const isFormFieldInvalid = ({ name, touched, errors }) => {
      const error = getIn(errors, name);
      const touch = getIn(touched, name);
      const isInvalid = touch && error;
      return isInvalid ? 'p-invalid' : '';
    };

    const getFormErrorMessage = ({ name, touched, errors }) => {
      return isFormFieldInvalid({ name, touched, errors }) ? (
        <span className="validation-error-message">{getIn(errors, name)}</span>
      ) : (
        <></>
      );
    };

    const branchOptions = this.branches.map(branch => ({
      label: branch.branch_name,
      value: branch.branch_id,
    }));

    const floorOptions = this.floors
      .filter(floor => floor.branch_id === branch_id)
      .map(floor => ({
        label: floor.floor_name,
        value: floor.floor_id,
      }));

    const componentOptions = this.componentTypeOptions.map(option => ({
      label: option.label,
      value: {
        component_id: option.component_id,
        component_child_id: option.component_child_id,
      },
    }));

    return (
      <>
        {/* Drag handle */}
        <div className="drag-handle">
          <div className="handle-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>

        {/* Branch field */}
        <div className="form-field">
          <Dropdown
            id={`selectedActionList[${index}].branch_id`}
            name="branch_id"
            value={branch_id}
            options={branchOptions}
            onChange={e =>
              fieldValueOnChanged(e, { arrayHelpers, index, actionItem })
            }
          />
        </div>

        {/* Floor field */}
        <div className="form-field">
          <Dropdown
            id={`selectedActionList[${index}].floor_id`}
            name="floor_id"
            value={floor_id}
            options={floorOptions}
            onChange={e =>
              fieldValueOnChanged(e, { arrayHelpers, index, actionItem })
            }
          />
        </div>

        {/* Component field */}
        <div className="form-field">
          <Dropdown
            id={`selectedActionList[${index}].component_id`}
            name="component_id"
            value={{
              component_id: component_id,
              component_child_id: component_child_id,
            }}
            onChange={e =>
              fieldValueOnChanged(e, { arrayHelpers, index, actionItem })
            }
            options={componentOptions}
            className={`${isFormFieldInvalid({
              name: `selectedActionList[${index}].component_id`,
              touched,
              errors,
            })}`}
          />
          {getFormErrorMessage({
            name: `selectedActionList[${index}].component_id`,
            touched,
            errors,
          })}
        </div>

        {/* Interval field */}
        <div className="form-field">
          <Dropdown
            id={`selectedActionList[${index}].interval`}
            name="interval"
            value={interval}
            options={this.intervalTypeOptions}
            onChange={e =>
              fieldValueOnChanged(e, { arrayHelpers, index, actionItem })
            }
          />
        </div>

        {/* Delete button */}
        <Button
          type="button"
          text
          severity="danger"
          className="icon-only-delete-button"
          onClick={e =>
            deleteButtonOnClicked(e, {
              arrayHelpers,
              item: actionItem,
              index,
            })
          }
        >
          <span className="delete-icon">
            <img src="assets/img/trash-icon.svg" alt="Delete" />
          </span>
        </Button>
      </>
    );
  };

  render() {
    const {
      isUpdating,
      isSignagePlayDialogVisible,
      selectedPlaySetItems,
      signageComponentsList,
    } = this.state;
    const { isLoading, notice } = this.props;
    const playItems = selectedPlaySetItems
      .filter(item => item.is_deleted !== true)
      .map(item => {
        return {
          ...item,
        };
      });
    for (const playItem of playItems) {
      delete playItem.initData;
    }

    const canPlaySignageView =
      signageComponentsList.length > 0;

    return (
      <>
        <ConfirmDialog />
        <Dialog
          showHeader={false}
          maximizable
          maximized
          closeOnEscape={true}
          className="signage-play-dialog"
          header=""
          visible={isSignagePlayDialogVisible}
          onHide={() => this.setState({ isSignagePlayDialogVisible: false })}
        >
          <SignagePlay items={playItems} notice={notice} />
        </Dialog>
        
        <div className="signage-components-overview-container">
          {isLoading || isUpdating ? (
            <div className="loading-overlay">
              <LoadingSpinner
                loadingText={isUpdating ? COMMON_TEXT.UPDATING_DATA : null}
              />
            </div>
          ) : (
            <div className="config-container">
              <div className='inner-container'>
                <div className="section-header">
                  <div className="section-title">コンポーネント</div>
                  <Button
                    type="submit"
                    form="signage-form"
                    className="figma-save-button"
                    loading={isUpdating}
                  >
                    <span className="figma-save-icon">
                      <img src="assets/img/save-setting-icon.svg" alt="Save" />
                    </span>
                    <span className="figma-save-label">保存</span>
                  </Button>
                </div>

                <div className="signage-mode-button">
                  <button
                    type="button"
                    className="start-signage-btn"
                    disabled={!canPlaySignageView}
                    onClick={e =>
                      this.setState({
                        isSignagePlayDialogVisible: true,
                        selectedPlaySetItems:
                          [...signageComponentsList] ?? [],
                      })
                    }
                  >
                    <img src="assets/img/play-icon.svg" alt="Play" className="play-icon" />
                    <span className="button-text">サイネージモード開始</span>
                  </button>
                </div>

                <div className="esc-hint">終了はESCキー</div>

                {this.renderListAction()}
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

SignageComponentOverview.propTypes = {
  isLoading: PropTypes.bool,
  signageComponentsList: PropTypes.array,
  notice: PropTypes.string,

  updateOverview: PropTypes.func,
};
export default SignageComponentOverview;
